<template>
  <div id="collectionDetailModal" class="content">
    <modal :show.sync="shouldShow" @hidden="onClickCancel" v-on:close="onClickCancel" footerClasses="justify-content-center" type="notice">
      <h4 slot="header" class="modal-title">
        <b>띄워주기</b>
      </h4>
      <MemberSelect
        class="member-select"
        v-if="types.type === 3"
        multiple
        :whitelist="members"
        :unitId="unitId"
        v-model="memberIds"
        :include-unit-artist="true"
        v-on:change="getArtistInfo"
      ></MemberSelect>
      <div class="row">
        <div class="col-sm-3">
          <h4 class="card-title text-left">타입</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <el-select @change="changeType" class="select-primary" size="large" placeholder="선택" v-model="types.type">
                <el-option v-for="option in types.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div v-if="types.type === 1 || types.type === 2" class="col-sm-3">
          <h4 class="card-title text-left">시작시간</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="시작시간">
                <el-date-picker type="datetime" placeholder="시작시간" v-model="startTime"></el-date-picker>
              </base-input>
            </div>
          </div>
        </div>
        <div v-if="types.type === 1 || types.type === 2" class="col-sm-3">
          <h4 class="card-title text-left">종료시간</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="종료시간">
                <el-date-picker type="datetime" placeholder="종료시간" v-model="endTime"></el-date-picker>
              </base-input>
            </div>
          </div>
        </div>
        <div v-if="types.type === 1 || types.type === 2" class="col-sm-3">
          <h4 class="card-title text-left">가중치</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input>
                <select class="form-control" v-model="weight">
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  <option>6</option>
                  <option>7</option>
                  <option>8</option>
                  <option>9</option>
                  <option>10</option>
                </select>
              </base-input>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="justify-content-center">
        <base-button class="footer-buttons col-6" type="success" round @click.native="onClickConfirm">확인</base-button>
        <base-button class="footer-buttons col-6" type="danger" round @click.native="onClickCancel">취소</base-button>
      </div>
    </modal>
  </div>
</template>
<script>
import MemberSelect from "@/pages/Components/MemberSelect.vue";
import { Modal, BaseInput } from "@/components/index";
import BaseButton from "@/components/BaseButton";

export default {
  name: "CollectionDetailModal",
  components: {
    MemberSelect,
    BaseButton,
    BaseInput,
    Modal,
  },
  created() {
    this.isProcessing = false;
  },
  data() {
    return {
      hours: null,
      weight: 5,
      startTime: null,
      endTime: null,
      isProcessing: false,
      memberIds: [],
      types: {
        type: 1,
        options: [
          {
            label: "인기갤러리",
            value: 1,
          },
          {
            label: "입덕갤러리",
            value: 3,
          },
          {
            label: "푸쉬알림",
            value: 4,
          },
        ],
      },
    };
  },
  props: {
    members: Array,
    unitId: Number,
    collectionId: Number,
    shouldShow: {
      type: Boolean,
      required: true,
    },
    onConfirm: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: true,
    },
  },
  methods: {
    changeType() {},
    onClickConfirm: async function () {
      if (this.isProcessing) {
        return;
      }
      await this.onConfirm();
      const param = {};
      let url = "";

      param.unitId = this.unitId;
      if (this.types.type === 1) {
        url = `/collection/${this.collectionId}/hotCollection`;
        if (!this.startTime || !this.endTime) {
          window.Toast.error("시간을 입력해주세요");
          return;
        }
        param.startTime = this.startTime;
        param.endTime = this.endTime;
        param.weight = this.weight;
      } else if (this.types.type === 3) {
        url = `/collection/${this.collectionId}/artistCollection`;
        param.members = this.memberIds;
        param.weight = this.weight;
        if (param.members.length === 0) {
          window.Toast.error("멤버를 한명이상 선택해주세요");
          return;
        }
      } else if (this.types.type === 4) {
      }
      this.isProcessing = true;
      return this.$axios
        .post(url, param)
        .then((res) => {
          if (this.types.type === 1) {
            window.Toast.success("설정되었습니다. 인기 갤러리 10분 이내로 앱에 반영됩니다.");
          } else {
            window.Toast.success("설정되었습니다");
          }
          this.isProcessing = false;
          this.startTime = null;
          this.endTime = null;
          this.weight = 5;

          this.onClickCancel();
        })
        .catch((error) => {
          window.Toast.error(error.response.data.error.message);
          this.isProcessing = false;
        });
    },
    onClickCancel: async function () {
      await this.onCancel();
    },
    getArtistInfo(memberId) {
      this.memberIds = memberId;
    },
  },
};
</script>
<style lang="scss">
#collectionDetailModal .modal-dialog {
  max-width: 800px !important;
}

.member-select {
  margin-bottom: 30px;
}

.footer {
  .footer-buttons {
    width: 100px;
  }
}
</style>
